import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ReactSignatureCanvas from 'react-signature-canvas';

import Modal from '../../../../components/common/Modal';
import Typography from '../../../../components/common/Typography';
import Button from '../../../../components/common/Button';
import { setCalc, signDocument, uploadPDFCommit } from '../../resultQuerySlice';
import { getAlertMessageFunction } from '../../../../common/Util';

const Signature = ({ modalCloseHandler, handleAuthentication }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('resultQuery');
  const canvasRef = useRef(null);
  // const [sign, setSign] = useState(null);

  const onSave = () => {
    if (canvasRef.current.toData() != undefined && canvasRef.current.toData().length != 0) {
      setSign(canvasRef.current.getTrimmedCanvas().toDataURL('image/png'));
      // signCertifyEnd(
      //   canvasRef.current.getTrimmedCanvas().toDataURL("image/png")
      // );
    } else {
      alertMessage(t('alertMessage5'));
    }
    // clickAuthBtn();
  };

  const signCertifyEnd = async () => {
    const alertMessage = getAlertMessageFunction();
    try {
      if (canvasRef.current.toData() == undefined || canvasRef.current.toData().length == 0) {
        alertMessage(t('alertMessage5'));
        return;
      }

      let sign = canvasRef.current.getTrimmedCanvas().toDataURL('image/png');
      const result = await dispatch(signDocument({ dataURL: sign })).unwrap();
      const { resultCode, resultMsg } = result;
      console.log(result);
      if (resultCode === '1') {
        const updatePDFResult = await dispatch(uploadPDFCommit()).unwrap();
        const { resultCode: updatePDFResultCode } = updatePDFResult;
        if (updatePDFResultCode === '1') {
          const setCalcResult = await dispatch(setCalc()).unwrap();
          const { resultCode: setCalcResultCode } = setCalcResult;
          if (setCalcResultCode === '1') {
            alertMessage(t('alertMessage7'));
            handleAuthentication();
            modalCloseHandler();
          }
        }
      } else if (resultMsg) {
        alertMessage(resultMsg);
      } else {
        alertMessage(t('alertMessage6'));
      }
    } catch (error) {
      console.error('서명 처리 중 오류 발생:', error);
      alertMessage(t('alertMessage6'));
    }
  };

  return (
    <Modal width="calc(100% - 32px)" innerStyle={{ padding: '30px 25px' }}>
      <div className="displayFlexColumn" style={{ gap: '20px' }}>
        <Typography variant="subtitleBold">{t('signatureModal.title')}</Typography>
        {/* 사인영역 */}
        <div className="canvasContainer">
          <div className="canvasButtonContainer">
            <Button
              variant="outline"
              color="gray"
              size="xSmall"
              value={t('signatureModal.subButton1')}
              onClick={() => canvasRef.current.clear()}
            />
            {/* <Button
              variant="outline"
              color="gray"
              size="xSmall"
              value={t('signatureModal.subButton2')} //저장
              onClick={onSave}
            /> */}
          </div>
          <ReactSignatureCanvas
            ref={canvasRef}
            canvasProps={{
              className: 'resultSignPad',
            }}
            clearOnResize={false}
          />
        </div>
        {/* 버튼 영역 */}
        <div className="displayFlex" style={{ justifyContent: 'flex-end', gap: '10px' }}>
          <Button color="sub" value={t('signatureModal.button1')} onClick={modalCloseHandler} />
          <Button value={t('signatureModal.button2')} onClick={signCertifyEnd} />
        </div>
      </div>
    </Modal>
  );
};

export default Signature;
